import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class InputHint extends Component {
    static get propTypes() {
        return {
            hintInfo: PropTypes.node.isRequired,
            hintText: PropTypes.string,
            type: PropTypes.string
        };
    }

    static defaultProps = {
        hintText: '?',
        type: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            showHintNotification: false
        };

        this.toggleHintNotification = this.toggleHintNotification.bind(this);
    }

    toggleHintNotification() {
        this.setState(
            ({ showHintNotification }) => ({
                showHintNotification: !showHintNotification
            })
        );
    }

    render() {
        const { hintText, hintInfo, type } = this.props;
        const { showHintNotification } = this.state;
        const wrapperClass = type ? `c-inputHint c-inputHint--${type}` : 'c-inputHint';

        return (
            <div className={wrapperClass} onClick={this.toggleHintNotification}>
                <span className="c-inputHint__hintText">{hintText}</span>
                {showHintNotification
                    && (
                        <div className="c-inputHint__info">
                            <span className="c-inputHint__close">x</span>
                            <span className="c-inputHint__infoText">{hintInfo}</span>
                        </div>
                    )
                }
            </div>
        );
    }
}
